import feedbackEdit from './edit.vue'
import feedbackList from './list.vue'


let a = Object.assign({ feedbackEdit, feedbackList},)
export default a
